import { render, staticRenderFns } from "./UiHeading.vue?vue&type=template&id=8916c416&scoped=true"
import script from "./UiHeading.vue?vue&type=script&lang=js"
export * from "./UiHeading.vue?vue&type=script&lang=js"
import style0 from "./UiHeading.vue?vue&type=style&index=0&id=8916c416&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8916c416",
  null
  
)

export default component.exports